import _ from 'lodash';

import CloseSidePanels from 'actions/customer/close_side_panels';
import OpenCommentPanel from 'actions/task/open_comment_panel';
import { SidePanelType } from 'models/side_panel';

export default class ToggleSidePanels {
  constructor(context) {
    this.context = context;
  }

  run(attrs) {
    const sidePanel = this.context.stores.sidePanel.get();

    const isAnswerOpen = sidePanel.isShowing(SidePanelType.ANSWER);
    const isCommentOpen = !!this.context.stores.commentPanel.get().selectedItemId;

    const currentLocation = this.context.stores.currentLocation.get();
    const { compositions } = this.context.stores.customers.storesFor(currentLocation.customerId);
    if (!attrs) {
      const composition = compositions.findBy({ id: currentLocation.currentCompositionId });
      attrs = {
        compositionId: _.get(composition, 'id'),
        conversationId: _.get(composition, 'conversationId'),
        customerId: _.get(composition, 'customerId'),
      };
    }

    if (!isCommentOpen && !isAnswerOpen) {
      // comment panel is closed & answer panel is closed; open comment panel
      this.context.executeAction(OpenCommentPanel, attrs);
    } else if (!isCommentOpen && isAnswerOpen) {
      // answer panel is open & no task selected; open comment panel (switches to task panel if attrs has itemId)
      this.context.executeAction(OpenCommentPanel, attrs);
    } else if (isCommentOpen && !isAnswerOpen) {
      // task panel is open; close all panels
      this.context.executeAction(CloseSidePanels, attrs);
    } else {
      // answer panel is open & task is selected; switch to task comment panel
      sidePanel.show(SidePanelType.TASK);
      this.context.stores.sidePanel.set(sidePanel);
    }
  }
}
